

























































import { createComponent, ref, reactive } from '@vue/composition-api'
import permissionCheckbox from '@/components/permissionCheckbox.vue'
import { getEnv } from '@/helpers/common'
import { envMap } from '@/constant'
import { ApplicantCmd, applicant } from '@/service/public'

export default createComponent({
    components: { permissionCheckbox },
    setup() {
        const envUrl = envMap[getEnv()].hostname

        const checkList = ref<[]>([])
        const showTipContent = ref<boolean>(false)
        const permissionCode = ref<string>()
        const cmd = reactive<ApplicantCmd>({
            permissionCodes: [],
            powers: [],
        })
        const submit = async () => {
            cmd.permissionCodes = (permissionCode.value && permissionCode.value.split(',')) || []
            cmd.powers = checkList.value
            const res = await applicant({ cmd })
            if (res && res.code === 0) {
                showTipContent.value = true
            }
        }
        const applicate = () => {
            checkList.value = []
            permissionCode.value = ''
            showTipContent.value = false
        }
        
        const validateIpt = () => {
            //  匹配中文
            permissionCode.value = permissionCode.value && permissionCode.value.replace(/[\u4e00-\u9fa5]/g, '')
        }
        return {
            permissionCode,
            applicate,
            checkList,
            showTipContent,
            submit,
            envUrl,
            validateIpt,
        }
    },
})
